import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import ListOfUsers from '../../components/ListOfUsers';
import moment from 'moment';
import 'moment/locale/pt-br';
import Link from '@material-ui/core/Link';
import LinkIcon from '@material-ui/icons/Link';
import DateFnsUtils from '@date-io/date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { instanceAxios } from '../../InstanceAxios';
import { formatMoney } from '../../utils/common';
import StatusNFE from '../../components/StatusNFE';

function NotasXmei() {
  const useStyles = makeStyles((theme) => ({
    root: {
      height: '',
      overflow: 'auto',
      width: '95%',
    },
    paper: {
      position: 'absolute',
      width: 800,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      top: `50%`,
      left: `50%`,
      transform: `translate(-50%, -50%)`,
      width: '80%',
      height: '80%',
      overflow: 'auto',
    },
    loading: {
      marginLeft: '50%',
    },
  }));

  const [columns, setColumns] = useState([
    { id: 'usuario', label: 'Usuário', minWidth: 150 },
    { id: 'descricao', label: 'Descrição', minWidth: 150 },
    { id: 'valor', label: 'Valor', minWidth: 50 },
    { id: 'dtEmissao', label: 'Data Emissão', minWidth: 50 },
    { id: 'status', label: 'Status', minWidth: 50 },
    { id: 'urlPdf', label: 'Pdf', minWidth: 50 },
  ]);
  const [openAlert, setOpenAlert] = useState(false);
  const [tipoAlert, setTipoAlert] = useState('');
  const [messageAlert, setMessageAlert] = useState('');
  const [ready, setReady] = useState(true);
  const [nomeUsuario, setNomeUsuario] = useState('');
  const [usuario, setUsuario] = useState(null);
  const [dtInicial, setDtInicial] = useState(
    moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD HH:mm')
  );
  const [dtFinal, setDtFinal] = useState(
    moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD HH:mm')
  );
  const [notas, setNotas] = useState([]);
  const [nota, setNota] = useState({});
  const [count, setCount] = useState(0);
  const [qtdPorPagina, setQtdPorPagina] = useState(10);
  const [page, setPage] = useState(0);

  useEffect(() => {
    atualizarNotas('', '', '', '', '');
  }, []);

  const clickAlert = () => {
    setOpenAlert(false);
    setTipoAlert('');
    setMessageAlert('');
  };

  const handleChangeUsuario = async (user) => {
    setUsuario(user);
    atualizarNotas(user.id, dtInicial, dtFinal, page, qtdPorPagina);
  };

  const handleDataIncial = async (data) => {
    const idUsuario = usuario ? usuario.id : '';
    setDtInicial(data);
    atualizarNotas(idUsuario, data, dtFinal, page, qtdPorPagina);
  };

  const handleDataFinal = async (data) => {
    const idUsuario = usuario ? usuario.id : '';
    setDtFinal(data);
    atualizarNotas(idUsuario, dtInicial, data, page, qtdPorPagina);
  };

  const handleChangePage = (event, newPage) => {
    const idUsuario = usuario ? usuario.id : '';
    setPage(newPage);
    atualizarNotas(idUsuario, dtInicial, dtFinal, newPage, qtdPorPagina);
  };

  const handleChangeRowsPerPage = (event) => {
    const idUsuario = usuario ? usuario.id : '';
    setQtdPorPagina(event.target.value);
    atualizarNotas(idUsuario, dtInicial, dtFinal, page, event.target.value);
  };

  const atualizarNotas = async (id, dtIni, dtFnl, pg, qpg) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .get(
        `/notasxmei?idUsuario=${id}&dtInicial=${dtIni}&dtFinal=${dtFnl}&limit=${qpg}&page=${pg}`
      )
      .then((res) => {
        setCount(res.data.count);
        setNotas(res.data.rows);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setNotas([]);
        setReady(true);
      });
  };

  const classes = useStyles();
  return (
    <>
      <h1>Notas Fiscais XMEI</h1>
      <Collapse in={openAlert}>
        <Alert severity={tipoAlert} onClick={clickAlert}>
          {messageAlert}
        </Alert>
      </Collapse>
      <Paper className={classes.root}>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
        <Collapse in={ready}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              padding: 10,
            }}
          >
            <Grid container>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <ListOfUsers
                  label="Nome do Cliente *"
                  width="40%"
                  userSelect={nomeUsuario}
                  setUserSelect={(user) => setNomeUsuario(user)}
                  setObjUser={(user) => handleChangeUsuario(user)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div align="right">
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={ptBrLocale}
                  >
                    <Grid container justify="space-around">
                      <KeyboardDatePicker
                        margin="normal"
                        id="picker-inicio"
                        label="Data Inicial"
                        format="dd/MM/yyyy"
                        value={dtInicial}
                        onChange={handleDataIncial}
                        KeyboardButtonProps={{
                          'aria-label': 'Mudar Data Inicial',
                        }}
                      />
                      <KeyboardDatePicker
                        margin="normal"
                        id="picker-final"
                        label="Data Final"
                        format="dd/MM/yyyy"
                        value={dtFinal}
                        onChange={handleDataFinal}
                        KeyboardButtonProps={{
                          'aria-label': 'Mudar Data Final',
                        }}
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </div>
              </Grid>
            </Grid>
          </div>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {notas.map((n) => {
                return (
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {n.User.nome}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {n.descricao}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {formatMoney(n.valor)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {moment(n.data_emissao).format('L')}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <StatusNFE status={n.nfe_status} />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      <Link href={n.url_pdf_enotas} target="_blank">
                        <LinkIcon />
                      </Link>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                component="div"
                style={{ backgroundColor: '#FFF' }}
                rowsPerPageOptions={[5, 10, 25]}
                count={count}
                rowsPerPage={qtdPorPagina}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage="Linhas por página"
              />
            </TableRow>
          </TableFooter>
        </Collapse>
      </Paper>
    </>
  );
}

export default NotasXmei;
